import { useQuery } from '@tanstack/react-query';

import useUserDetails from '@/hooks/useUserDetails';
import type { FeedFilters } from '@/pages/Markets/MarketsComponents/Feed/api/fetchFeedData';
import { fetchFeedData } from '@/pages/Markets/MarketsComponents/Feed/api/fetchFeedData';
import { feedKeys } from '@/pages/Markets/MarketsComponents/Feed/queries/feed.keys';

export const useFeedData = (metadata: FeedFilters) => {
  const { isUserExpired } = useUserDetails();

  return useQuery({
    queryKey: feedKeys.data(metadata),
    queryFn: () => fetchFeedData(metadata),
    refetchInterval: 10000,
    enabled: !isUserExpired
  });
};
